var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { getCookie } from './helpers';
import { checkNewVersion } from './checkVersion';
import { updateVersionModal } from './updateVersionModal';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-CSRFToken'] = getCookie('csrftoken');
export var requestWithCheckVersion = function (method, url, options) {
    if (options === void 0) { options = {}; }
    var enabledCheckVersion = options.enabledCheckVersion, restOptions = __rest(options, ["enabledCheckVersion"]);
    return axios(__assign({ method: method, url: url }, restOptions)).then(function (response) {
        var isNewVersion = enabledCheckVersion && checkNewVersion(response);
        isNewVersion && updateVersionModal();
        return response;
    });
};
//# sourceMappingURL=requestWithCheckVersion.js.map